import { forwardRef } from 'react'
import Skeleton from '../../Skeleton'
import { TabsList, TabsTrigger } from '../../ui/tabs'

interface TabTriggerLoadingProps {
  tabsListClassName?: string
  tabsTriggerClassName?: string
  skeletonsCount?: number
}

const TabTriggerLoading = forwardRef<HTMLDivElement, TabTriggerLoadingProps>(
  ({ tabsListClassName, tabsTriggerClassName, skeletonsCount }, tabsListRef) => {
    return (
      <TabsList className={tabsListClassName} ref={tabsListRef}>
        {new Array(skeletonsCount).fill(null).map((_, index) => (
          <TabsTrigger key={`loading_tab_${index}`} value={index.toString()} className={tabsTriggerClassName} disabled>
            <Skeleton className="bg-white-100" />
          </TabsTrigger>
        ))}
      </TabsList>
    )
  },
)

export default TabTriggerLoading
